export default "__VITE_ASSET__069933f6__"